import { render, staticRenderFns } from "./DataCards.vue?vue&type=template&id=fddc5b48&"
import script from "./DataCards.vue?vue&type=script&lang=ts&"
export * from "./DataCards.vue?vue&type=script&lang=ts&"
import style0 from "./DataCards.vue?vue&type=style&index=0&id=fddc5b48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports